import {
	Vector3,
	Box3,
} from 'three';

import {OlivioLuminaire} from './olivioLuminaire';

class OlivioSistemaLuminaire extends OlivioLuminaire {
	static designName = 'sistema';

	static poleSizes = {
		5: {
			height: 5,
			topMargin: 0.25,
			topDiameter: 0.092,
			bottomDiameter: 0.155
		},
		6: {
			height: 6,
			topMargin: 0.25,
			topDiameter: 0.092,
			bottomDiameter: 0.155
		},
		7: {
			height: 7,
			topMargin: 0.25,
			topDiameter: 0.092,
			bottomDiameter: 0.166
		},
		8: {
			height: 8,
			topMargin: 0.25,
			topDiameter: 0.092,
			bottomDiameter: 0.177
		},
		9: {
			height: 9,
			topMargin: 0.25,
			topDiameter: 0.092,
			bottomDiameter: 0.188
		},
		10: {
			height: 10,
			topMargin: 0.25,
			topDiameter: 0.092,
			bottomDiameter: 0.199
		},
		11: {
			height: 11,
			topMargin: 0.3,
			topDiameter: 0.111,
			bottomDiameter: 0.218
		},
		12: {
			height: 12,
			topMargin: 0.3,
			topDiameter: 0.111,
			bottomDiameter: 0.228
		},
	};

	static models = {
		pole: {},
		bracket: {},
	};

	static modelPatterns = [
		{type: 'pole', pattern: /^Sistema_Pole_[^0-9]*_(?<id>[0-9]+)$/i, storageKeys: ['id']},
		{type: 'bracket', pattern: /^Sistema_(?<id>[0-9]+)_Bracket$/i, storageKeys: ['id']},
	];

	static headLinkOffsets = {};
	static internalOffsets = null;

	static defaultConfig = {
		poleHeight: 12,
		numberOfHeads: 8,
		layout: 'spiral',
		heightMax: 11.00,
		heightMin: 5.00,
		angleMax: 360,
		angleMin: 0,
		bracket: 'sistema1',
	};


	static getPoleId(configValues) {
		return String(configValues.poleHeight);
	}

	static getBracketId(configValues, index) {
		return configValues.bracket.match(/[0-9]+/)[0];
	}

	static calculateLaValue(poleHeight, actualHeight) {
		return poleHeight - actualHeight;
	}


	getBracketCollisionBoxInfo(configValues, bracket, bracketMesh) {
		const self = this.constructor;
		let bracketOffset = null;
		let bracketSize = null;
		const bracketBox = new Box3();
		bracketBox.setFromObject(bracket);
		bracketSize = new Vector3();
		const plane = new Box3(
			new Vector3(bracketBox.min.x + 0.005, bracketBox.min.y, bracketBox.min.z),
			new Vector3(bracketBox.min.x + 0.04, bracketBox.min.y + 0.12, bracketBox.max.z)
		);
		bracketBox.intersect(plane);
		bracketBox.getSize(bracketSize);
		bracketOffset = new Vector3();
		bracketBox.getCenter(bracketOffset);
		bracketOffset.x -= bracketMesh.position.x;
		return {bracketOffset: bracketOffset, bracketSize: bracketSize};
	}


}


for (const id of Object.keys(OlivioSistemaLuminaire.poleSizes)) {
	const entry = OlivioSistemaLuminaire.poleSizes[id];
	const h = entry.height - entry.topMargin;
	entry.xBaseOffset = (entry.topDiameter / 2);
	const b = (entry.bottomDiameter / 2) - entry.xBaseOffset;
	entry.ratio = b / h;
	entry.maxHeight = h;
	const i = Math.sqrt(h**2 + b**2);
	entry.verticalAngle = Math.asin(b / i) * (180 / Math.PI); // deg
}


export {OlivioSistemaLuminaire};

